/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { searchJobs } from "../../services/jobs"; // Ensure path is correct
import com_logo_1 from "../../img/com_logo_1.jpg"; // Ensure path is correct
import { categories } from "../data/job_data"; // Import categories data

const Listing = (props) => {
  console.log("Jobs Data:", props);
  const [jobLists, setjobLists] = useState([]);
  const [inputs, setInputs] = useState({ category: null, job_type: null }); // Initialize as arrays if multi-select, or handle logic below
  const [loading, setLoader] = useState(true);

  const jobTypes = ["Full Time", "Part Time", "Remote"];

  useEffect((e) => {
    setLoader(true);
    if (props?.jobs) {
      setjobLists(props?.jobs);
      setLoader(false);
      setInputs((values) => ({ ...values, companyId: props?.companyId }));
    }
  }, [props?.jobs]);

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoader(true);
    
    console.log("Search Inputs:", inputs);
    // Logic to handle search.
    // Note: Ensure your searchJobs API can handle the input format.
    // If your API expects a specific string, you might need to formatted inputs here.
    try {
      const response = await searchJobs(inputs).then((res) => res.json());
      if (response) {
        setjobLists(response);
      } else {
        setjobLists([]);
      }
    } catch (error) {
      console.error("Search error", error);
    } finally {
      setLoader(false);
    }
  };

  // Handle Checkbox Changes
  const handleCheckboxChange = (e) => {
    const { name, value, checked } = e.target;

    // NOTE: This logic assumes your API expects a single string for category/type.
    // If you want to allow multiple selections (e.g., filtering by Remote AND Full Time),
    // you would need to change 'inputs' state to hold arrays and update searchJobs to handle it.
    // For this UI to work with your existing simple logic, we treat checkboxes like radio buttons
    // (or just overwrite the value).

    if (checked) {
      setInputs((values) => ({ ...values, [name]: value }));
    } else {
      // If unchecked, clear that specific filter
      setInputs((values) => ({ ...values, [name]: undefined }));
    }
  };

  return (
    <div className="container-fluid py-5">
      <div className="container">
        <h1 className="mb-5 wow fadeInUp" data-wow-delay="0.1s">
          Find Your Dream Job
        </h1>

        <div className="row">
          {/* --- LEFT SIDEBAR (FILTERS) --- */}
          <div className="col-lg-3 mb-4">
            <div className="card border-0 shadow-sm p-4">
              <h5 className="mb-4">Filter Jobs</h5>
              <form onSubmit={handleSearch}>
                {/* Category Section */}
                <div className="mb-4">
                  <h6 className="fw-bold mb-3">Category</h6>
                  {categories.map((cat) => (
                    <div className="form-check mb-2" key={cat.id}>
                      <input
                        className="form-check-input"
                        type="checkbox" // Note: If you only allow one selection, consider type="radio"
                        name="category"
                        // 1. Pass the ID as the value (e.g., 1, 2, 3)
                        value={cat.id}
                        id={`cat-${cat.id}`}
                        // 2. Compare the stored ID in state with the current ID
                        // We use '==' to handle cases where state is a number (1) but DOM value is string ("1")
                        checked={inputs.category == cat.id}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`cat-${cat.id}`}
                      >
                        {/* 3. Display the text label */}
                        {cat.label}
                      </label>
                    </div>
                  ))}
                </div>

                <hr />

                {/* Job Type Section */}
                <div className="mb-4">
                  <h6 className="fw-bold mb-3">Job Type</h6>
                  {jobTypes.map((type, index) => (
                    <div className="form-check mb-2" key={index}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="job_type"
                        value={type}
                        id={`type-${index}`}
                        checked={inputs.job_type === type}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`type-${index}`}
                      >
                        {type}
                      </label>
                    </div>
                  ))}
                </div>

                <button type="submit" className="btn bg-primary w-100 py-2 text-white">
                  Apply Filters
                </button>
              </form>
            </div>
          </div>

          {/* --- RIGHT CONTENT (JOB LIST) --- */}
          <div className="col-lg-9">
            {loading && (
              <div className="d-flex justify-content-center align-items-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}

            {!loading && (
              <div className="tab-content">
                <div id="tab-1" className="tab-pane fade show active">
                  {jobLists.length > 0 ? (
                    jobLists.map((jList) => (
                      <div
                        key={jList.id}
                        className="job-item p-4 mb-4 border rounded shadow-sm bg-white"
                      >
                        <div className="row g-4">
                          <div className="col-sm-12 col-md-8 d-flex align-items-center">
                            <img
                              className="flex-shrink-0 img-fluid border rounded"
                              src={jList.company_logo || com_logo_1}
                              alt="Company Logo"
                              style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "cover",
                              }}
                            />
                            <div className="text-start ps-4">
                              <h5 className="mb-3">
                                <Link
                                  to={`/job-details/${jList.id}`}
                                  className="text-dark text-decoration-none"
                                >
                                  {jList.title}
                                </Link>
                              </h5>

                              {/* --- NEW: Category Section Added Here --- */}
                              <span className="text-truncate me-3 text-muted">
                                <i className="far fa-folder text-primary me-2" />
                                {/* {jList.category} */}
                                {
                                  categories.find((c) => c.id == jList.category)
                                    ?.label
                                }
                              </span>
                              {/* -------------------------------------- */}

                              <span className="text-truncate me-3 text-muted">
                                <i className="fa fa-map-marker-alt text-primary me-2" />
                                {jList.location}
                              </span>
                              <span className="text-truncate me-3 text-muted">
                                <i className="far fa-clock text-primary me-2" />
                                {jList.job_type}
                              </span>
                              <span className="text-truncate me-0 text-muted">
                                <i className="far fa-money-bill-alt text-primary me-2" />
                                {jList.salary}
                              </span>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-4 d-flex flex-column align-items-start align-items-md-end justify-content-center">
                            <div className="d-flex mb-3">
                              <Link
                                className="btn btn-primary"
                                to={`/job-details/${jList.id}`}
                              >
                                Apply Now
                              </Link>
                            </div>
                            <small className="text-muted">
                              <i className="far fa-calendar-alt text-primary me-2" />
                              {jList.posted_date
                                ? jList.posted_date
                                : "Recently"}
                            </small>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-5">
                      <h4>No jobs found matching your criteria.</h4>
                      <p className="text-muted">Try adjusting your filters.</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Listing;
